function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React, { Component } from 'react';
import _ from 'lodash';
import { _CompactTestScoresContainer, _TestScore } from "./styles";
import { _RoundedBox } from "../style/CommonStyles";
import { ENGLISH_TESTS_ORDER } from "../../constants/consts";
var CompactTestScores = /*#__PURE__*/function (_Component) {
  _inherits(CompactTestScores, _Component);
  var _super = _createSuper(CompactTestScores);
  function CompactTestScores() {
    var _this;
    _classCallCheck(this, CompactTestScores);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _super.call.apply(_super, [this].concat(args)), _this.renderEnglishExamScores = function (testScores) {
      var map = ENGLISH_TESTS_ORDER[testScores.type.toLowerCase()];
      if (!map) return [];
      return Object.keys(map).map(function (scoreTitle) {
        return {
          title: scoreTitle,
          numbers: [testScores[map[scoreTitle]]]
        };
      });
    }, _this.renderGreExamScores = function (testScores) {
      return [{
        title: 'V',
        numbers: [testScores.verbal_score, "".concat(testScores.verbal_rank, "%")]
      }, {
        title: 'Q',
        numbers: [testScores.quantitative_score, "".concat(testScores.quantitative_rank, "%")]
      }, {
        title: 'W',
        numbers: [testScores.writing_score, "".concat(testScores.writing_rank, "%")]
      }];
    }, _this.renderGmatExamScores = function (testScores) {
      return [{
        title: 'V',
        numbers: [testScores.verbal_score, "".concat(testScores.verbal_rank, "%")]
      }, {
        title: 'Q',
        numbers: [testScores.quantitative_score, "".concat(testScores.quantitative_rank, "%")]
      }, {
        title: 'W',
        numbers: [testScores.writing_score, "".concat(testScores.writing_rank, "%")]
      }, {
        title: 'T',
        numbers: [testScores.total_score, "".concat(testScores.total_rank, "%")]
      }];
    }, _assertThisInitialized(_this)));
  }
  _createClass(CompactTestScores, [{
    key: "render",
    value: function render() {
      var info = [];
      switch (this.props.type) {
        case 'gre':
          info = this.renderGreExamScores(this.props.testScores);
          break;
        case 'gmat':
          info = this.renderGmatExamScores(this.props.testScores);
          break;
        default:
          info = this.renderEnglishExamScores(this.props.testScores);
          break;
      }
      return /*#__PURE__*/React.createElement(_CompactTestScoresContainer, {
        column: this.props.column
      }, _.map(info, function (x) {
        return /*#__PURE__*/React.createElement(_TestScore, {
          key: "".concat(x.title, "-compactkey1")
        }, /*#__PURE__*/React.createElement("span", null, x.title), /*#__PURE__*/React.createElement("span", null, _.map(x.numbers, function (y) {
          return /*#__PURE__*/React.createElement(_RoundedBox, {
            key: "".concat(y, "-compactkey2")
          }, y);
        })));
      }));
    }
  }]);
  return CompactTestScores;
}(Component);
export default CompactTestScores;